<div
  class="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden"
>
  <div
    class="px-4 py-3 flex items-center justify-between border-b border-gray-100 bg-white"
  >
    <div class="flex items-center space-x-1">
      <h3 class="text-[11px] font-bold text-gray-800 uppercase tracking-widest">
        Line Items
      </h3>
      <span
        class="px-1.5 py-0.5 rounded bg-gray-50 text-[9px] font-bold text-gray-400 uppercase"
        >{{ formArray.length }} Records</span
      >
    </div>
    <button
      (click)="addRow()"
      class="text-[10px] font-bold text-gray-500 hover:text-black uppercase tracking-widest"
    >
      + Add Row
    </button>
  </div>

  <div class="w-full overflow-x-auto max-h-[450px] custom-scrollbar">
    <table class="w-full border-collapse">
      <thead class="bg-gray-50 sticky top-0 z-10">
        <tr>
         <ng-container *ngFor="let col of columns">

          <th
            *ngIf="isColumnVisible(col)"
            class="px-4 py-2 text-left text-[10px] font-bold text-gray-400 uppercase tracking-widest">

            {{ col.label }}

          </th>

        </ng-container>
          <th
            class="px-4 py-2 text-right text-[10px] font-bold text-gray-400 uppercase w-20"
          >
            Actions
          </th>
        </tr>
      </thead>

      <tbody class="divide-y divide-gray-50">
        <tr
          *ngFor="let row of formArray.controls; let i = index"
          [formGroup]="$any(row)"
          class="hover:bg-gray-50/40 transition-colors"
        >
         <ng-container *ngFor="let col of columns">

          <td
            *ngIf="isColumnVisible(col,$any(row))"
            class="px-3 py-1 align-middle">

            <div [ngSwitch]="col.type">

              <!-- TEXT -->
              <app-line-cell-text
                *ngSwitchCase="'text'"
                [row]="$any(row)"
                [col]="col">
              </app-line-cell-text>

              <!-- NUMBER -->
              <app-line-cell-number
                *ngSwitchCase="'number'"
                [row]="$any(row)"
                [col]="col">
              </app-line-cell-number>

              <!-- MONEY -->
              <app-line-cell-money
                *ngSwitchCase="'money'"
                [row]="$any(row)"
                [col]="col">
              </app-line-cell-money>

              <!-- SELECT -->
              <app-line-cell-select
                *ngSwitchCase="'select'"
                [row]="$any(row)"
                [col]="col">
              </app-line-cell-select>

              <!-- AUTOCOMPLETE -->
              <app-line-cell-autocomplete
                *ngSwitchCase="'autocomplete'"
                [row]="$any(row)"
                [col]="col"
                [form]="form">
              </app-line-cell-autocomplete>

              <!-- DATE -->
              <app-line-cell-date
                *ngSwitchCase="'date'"
                [row]="$any(row)"
                [col]="col">
              </app-line-cell-date>

              <!-- TAX -->
              <app-line-cell-tax
                *ngSwitchCase="'tax'"
                [row]="$any(row)"
                [col]="col"
                (taxClick)="openTaxDialog($any(row))">
              </app-line-cell-tax>

            </div>

          </td>

        </ng-container>

          <td class="px-4 py-1 text-right">
            <!-- <button
                type="button"
                (click)="openTaxDialog($any(row))"
                class="text-blue-600 hover:text-blue-800 mr-2">
                Tax
            </button> -->
            
            <button
              (click)="removeRow(i)"
              class="text-gray-300 hover:text-red-500 p-1"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                ></path>
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div
  *ngIf="
    config?.lineConfig
      ?.taxDrawer
      ?.enabled
  "
  class="flex justify-end mt-3">

  <button
    type="button"
    class="kt-btn kt-btn-outline kt-dropdown-toggle mb-2 mr-2"
    data-kt-drawer-toggle="#drawer_tax_breakdown"
    (click)="openTaxDrawer()">

    {{
      config.lineConfig
        ?.taxDrawer
        ?.label
        || 'Tax Details'
    }}

  </button>

</div>